import e from "./ExamplePicker.vue.script.js";
//#region src/code-example/components/ExamplePicker.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=ExamplePicker.vue.js.map